import { CapaDeModal } from '@/shared/components/CapaDeModal'
import { estiloDeBoton } from '@/shared/lib/estilosDeBoton'
import { X } from 'lucide-react'

interface ConfirmActionModalProps {
  isOpen: boolean
  title: string
  message: string
  confirmText: string
  cancelText?: string
  /** Color de la acción: `peligro` para lo destructivo. */
  variante?: 'primario' | 'peligro' | 'exito'
  onConfirm: () => void
  onCancel: () => void
  isLoading?: boolean
}

const ConfirmActionModal = ({
  isOpen,
  title,
  message,
  confirmText,
  cancelText = 'Cancelar',
  variante = 'primario',
  onConfirm,
  onCancel,
  isLoading = false,
}: ConfirmActionModalProps) => {
  if (!isOpen) return null

  return (
    // El fondo y el centrado los pone CapaDeModal, montada en el body: aquí
    // vivían dentro de la pantalla y se recortaban con ciertos contenedores.
    <CapaDeModal onClickFondo={onCancel}>
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full p-6">
          {/* Close button */}
          <button
            onClick={onCancel}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
            disabled={isLoading}
          >
            <X className="w-5 h-5" />
          </button>

          {/* Content */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
            <p className="text-sm text-gray-600">{message}</p>
          </div>

          {/* Actions */}
          <div className="flex gap-3 justify-end">
            <button
              onClick={onCancel}
              disabled={isLoading}
              className={estiloDeBoton('secundario')}
            >
              {cancelText}
            </button>
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className={estiloDeBoton(variante)}
            >
              {isLoading ? (
                <div className="flex items-center gap-2">
                  <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent" />
                  Procesando...
                </div>
              ) : (
                confirmText
              )}
            </button>
          </div>
        </div>
    </CapaDeModal>
  )
}

export default ConfirmActionModal
